var _rect, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 81,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    x: 1.5,
    y: 9.5,
    stroke: "#C6C8D7",
    strokeWidth: 3,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C8D7",
    d: "M2 23h60v3H2zm8 12h10v3H10zm0 10h10v3H10zm0 10h10v3H10zm17-20h10v3H27zm0 10h10v3H27zm0 10h10v3H27zm17-20h10v3H44zm0 10h10v3H44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C6C8D7",
    strokeWidth: 3,
    d: "M24 9a7 7 0 10-7 7m37-7a7 7 0 10-7 7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 66.5,
    r: 13,
    fill: "#fff",
    stroke: "#C6C8D7",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C8D7",
    d: "M56 59h3v10h-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C8D7",
    d: "M63 66v3h-7v-3z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MiIgaGVpZ2h0PSI4MSIgZmlsbD0ibm9uZSI+PHJlY3Qgd2lkdGg9IjYxIiBoZWlnaHQ9IjYxIiB4PSIxLjUiIHk9IjkuNSIgc3Ryb2tlPSIjQzZDOEQ3IiBzdHJva2Utd2lkdGg9IjMiIHJ4PSIxLjUiLz48cGF0aCBmaWxsPSIjQzZDOEQ3IiBkPSJNMiAyM2g2MHYzSDJ6bTggMTJoMTB2M0gxMHptMCAxMGgxMHYzSDEwem0wIDEwaDEwdjNIMTB6bTE3LTIwaDEwdjNIMjd6bTAgMTBoMTB2M0gyN3ptMCAxMGgxMHYzSDI3em0xNy0yMGgxMHYzSDQ0em0wIDEwaDEwdjNINDR6Ii8+PHBhdGggc3Ryb2tlPSIjQzZDOEQ3IiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0yNCA5YTcgNyAwIDEgMC03IDdtMzctN2E3IDcgMCAxIDAtNyA3Ii8+PGNpcmNsZSBjeD0iNTcuNSIgY3k9IjY2LjUiIHI9IjEzIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNDNkM4RDciIHN0cm9rZS13aWR0aD0iMyIvPjxwYXRoIGZpbGw9IiNDNkM4RDciIGQ9Ik01NiA1OWgzdjEwaC0zeiIvPjxwYXRoIGZpbGw9IiNDNkM4RDciIGQ9Ik02MyA2NnYzaC03di0zeiIvPjwvc3ZnPg==";
export { SvgSchedule as ReactComponent };